import {customElement} from "lit/decorators/custom-element.js";
import {AbstractTileComponent} from "./abstract-tile.component";

/** A Linkview tile with no link target — pure tag registration, reuses
 *  `AbstractTileComponent`'s default `_renderBody()` (a non-interactive
 *  `<div>` around icon+text). */
@customElement('link-tile-plain')
export class LinkTilePlainComponent extends AbstractTileComponent<null> {
}
